import { Navigate } from "react-router-dom";
import { useDeepLinkContext } from "@/hooks/tauri/DeepLinkProvider";
import { AppRoutes } from "@/infra/router";
import { LoadingOverlay, useHomepageRedirect, HomepageRedirectTarget } from "@akina/presentation";

export const HomePage = () => {
  const { isDeepLinkHandled } = useDeepLinkContext();
  const target = useHomepageRedirect(state => state.target);

  if (!isDeepLinkHandled) {
    return <LoadingOverlay />;
  }

  if (!target) return <Navigate to={AppRoutes.Dashboard} replace />;
  if (target === HomepageRedirectTarget.OnboardingError) {
    return <Navigate to={AppRoutes.OnboardingError} replace />;
  } else {
    return <Navigate to={AppRoutes.Dashboard} replace />;
  }
};
